/**
 * vue-i18n 設定
 *
 * 還原自 chunk-common.js 模組 b7ce。
 * 語言對應 { tw, en } 與初始 locale 取自 store.state.lang，與原始一致。
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'

import tw from './tw.json'
import en from './en.json'

Vue.use(VueI18n)

export default new VueI18n({
  locale: store.state.lang,

  /*
   * 找不到鍵時退回英文，而不是把鍵名當文案顯示出來。
   *
   * vue-i18n 的預設行為是「找不到就回傳鍵本身」。2026-08-21 查到的實例：
   * tw.json 缺 err_1290~err_1297 共 8 個鍵，而 ResultApp.vue 的
   * LINE_PAY_ERROR_CODES 裡有它們 —— 於是 LINE Pay 回 1292 時，
   * 客人的錯誤對話框上顯示的字面就是「err_1292」。
   * 資料庫查得到三筆真實訂單走過這條路（2× 1292、1× 1291）。
   *
   * 那八個鍵已經補上了。這一行是防下一次 —— 少一則文案時，
   * 客人至少看到英文的「The card has been suspended.」，
   * 而不是一個看起來像程式壞掉的字串。
   */
  fallbackLocale: 'en',
  messages: { tw, en }
})
